// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__3hBjg","heroContainer":"Layout_heroContainer__hYWQW"};